var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdraw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6777_14201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.75C12 19.3413 12.6321 20.8674 13.7574 21.9926C14.8826 23.1179 16.4087 23.75 18 23.75C19.5913 23.75 21.1174 23.1179 22.2426 21.9926C23.3679 20.8674 24 19.3413 24 17.75C24 16.1587 23.3679 14.6326 22.2426 13.5074C21.1174 12.3821 19.5913 11.75 18 11.75C16.4087 11.75 14.8826 12.3821 13.7574 13.5074C12.6321 14.6326 12 16.1587 12 17.75Z",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7581 21.992L22.2431 13.507",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.75H1C1.01341 15.6075 1.25125 14.4788 1.7 13.428C2.19 12.447 4.239 11.767 6.811 10.815C7.506 10.557 7.392 8.741 7.084 8.402C6.59262 7.87101 6.21918 7.24204 5.98823 6.55642C5.75728 5.87081 5.67405 5.14408 5.744 4.424C5.69992 3.96555 5.75073 3.50293 5.89327 3.06498C6.0358 2.62703 6.26701 2.22313 6.57248 1.87844C6.87795 1.53376 7.25113 1.25568 7.66878 1.06153C8.08642 0.86739 8.53958 0.761343 9 0.75C9.46042 0.761343 9.91358 0.86739 10.3312 1.06153C10.7489 1.25568 11.1221 1.53376 11.4275 1.87844C11.733 2.22313 11.9642 2.62703 12.1067 3.06498C12.2493 3.50293 12.3001 3.96555 12.256 4.424C12.3265 5.14379 12.2439 5.87035 12.0136 6.55595C11.7834 7.24154 11.4107 7.87067 10.92 8.402C10.612 8.741 10.498 10.557 11.193 10.815L12.5 11.296",
    stroke: "#13100D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6777_14201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.25)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdraw);
export default __webpack_public_path__ + "static/media/withdraw.4a5ac6b38ca8c0c74fdb522958eb7411.svg";
export { ForwardRef as ReactComponent };